module.exports = __webpack_public_path__ + "contatore-1-m-wia.png";